// Translation for hi
export const hi = {
        common: {
            save: 'सहेजें',
            cancel: 'रद्द करें',
            close: 'बंद करें',
            delete: 'हटाएं',
            edit: 'संपादित करें',
            activate: 'सक्रिय करें',
            add: 'जोड़ें',
            saving: 'सहेजा जा रहा है...',
            loading: 'लोड हो रहा है...',
            active: 'सक्रिय',
            inUse: 'उपयोग में',
            test: 'परिक्षण',
            searchApps: 'ऐप्स खोजें...',
            betaBanner: 'बीटा - सेवा अभी उपलब्ध नहीं है!'
        },
        header: {
            creditBalance: 'शेष राशि',
            minutes: 'मिनट'
        },
        auth: {
            signIn: 'साइन इन करें',
            signUp: 'साइन अप करें',
            username: 'उपयोगकर्ता नाम',
            password: 'पासवर्ड',
            continue: 'जारी रखें',
            noAccount: 'क्या आपके पास खाता नहीं है?',
            hasAccount: 'क्या आपके पास पहले से खाता है?',
            loginError: 'लॉगिन विफल रहा',
            invalidCredentials: 'अमान्य उपयोगकर्ता नाम या पासवर्ड',
            rateLimited: 'बहुत अधिक लॉगिन प्रयास। कृपया थोड़ी देर प्रतीक्षा करें।',
            sessionExpired: 'आपका सत्र समाप्त हो गया है। कृपया एक नए मैजिक लिंक का उपयोग करें।',
            magicLinkInvalid: 'लॉगिन लिंक अमान्य है या समाप्त हो गया है।',
            magicLinkSuccess: 'आपका स्वागत है! आपको सफलतापूर्वक लॉगिन कर लिया गया है।',
            magicLinkProcessing: 'लॉगिन प्रोसेसिंग...',
            connectionError: 'कनेक्शन त्रुटि। कृपया पुनः प्रयास करें।'
        },
        profile: {
            myProgress: 'मेरी सीखने की प्रगति',
            signOut: 'साइन आउट',
            plan: 'योजना: '
        },
        settings: {
            title: 'सेटिंग्स',
            tabs: {
                uiSettings: 'UI सेटिंग्स',
                systemPrompt: 'सिस्टम प्रॉम्प्ट',
                llmProfiles: 'LLM प्रोफाइल',
                ttsProfiles: 'TTS प्रोफाइल',
                language: 'भाषा',
            },
            uiSettings: {
                title: 'यूजर इंटरफेस',
                themeMode: 'थीम मोड',
                darkMode: 'डार्क मोड',
                lightMode: 'लाइट मोड',
                themeColor: 'थीम रंग',
                themeColorDesc: 'बटन, आइकन और हाइलाइट्स के लिए एक्सेंट रंग चुनें',
                background: 'पृष्ठभूमि',
                backgroundDesc: 'अपने कार्यक्षेत्र के लिए एक पृष्ठभूमि चुनें',
                selectBackgroundColor: 'पृष्ठभूमि रंग चुनें',
                backgrounds: {
                    cyberSchooling: 'साइबर स्कूलिंग',
                    focus: 'फोकस',
                    concentration: 'एकाग्रता',
                    relaxation: 'विश्राम',
                    lianas: 'लिआनास',
                    color: 'रंग'
                },
                backgroundColors: {
                    deepDark: 'गहरा काला',
                    darkGrey: 'गहरा ग्रे',
                    midnightBlue: 'मिडनाइट ब्लू',
                    indigo: 'इंडिगो',
                    darkTeal: 'गहरा चैती',
                    brown: 'भूरा',
                    darkRed: 'गहरा लाल',
                    deepPurple: 'गहरा बैंगनी',
                    pureWhite: 'शुद्ध सफेद',
                    softWhite: 'सॉफ्ट व्हाइट',
                    lightGrey: 'हल्का ग्रे',
                    paleBlue: 'हल्का नीला',
                    paleGreen: 'हल्का हरा',
                    paleOrange: 'हल्का नारंगी',
                    lavender: 'लैवेंडर',
                    blueGrey: 'ब्लू ग्रे'
                }
            },
            systemPrompt: {
                label: 'सिस्टम प्रॉम्प्ट:',
                placeholder: 'सिस्टम प्रॉम्प्ट लोड हो रहा है...',
                emptyError: 'सिस्टम प्रॉम्प्ट खाली नहीं हो सकता!',
                saveSuccess: '✓ सिस्टम प्रॉम्प्ट सफलतापूर्वक सहेजा गया!',
                loadError: 'सिस्टम प्रॉम्प्ट लोड करने में त्रुटि',
                saveError: 'सहेजने में त्रुटि'
            },
            llmProfiles: {
                addButton: '+ नया कनेक्शन जोड़ें',
                newConnection: 'नया कनेक्शन',
                editConnection: 'कनेक्शन संपादित करें',
                emptyState: 'कोई LLM कनेक्शन उपलब्ध नहीं है। जोड़ने के लिए नीचे क्लिक करें।',
                loadingProfiles: 'प्रोफ़ाइल लोड हो रही है...',
                nameLabel: 'नाम *',
                namePlaceholder: 'जैसे: OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API कुंजी *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'मॉडल *',
                modelPlaceholder: 'gpt-4, mistral-tiny, आदि।',
                allFieldsRequired: 'सभी फ़ील्ड भरे जाने चाहिए!',
                saveSuccess: '✓ प्रोफ़ाइल सफलतापूर्वक सहेजी गई!',
                deleteConfirm: 'क्या आप वास्तव में "{name}" को हटाना चाहते हैं?',
                profileNotFound: 'प्रोफ़ाइल नहीं मिली!',
                loadError: 'प्रोफ़ाइल लोड करने में त्रुटि',
                saveError: 'सहेजने में त्रुटि',
                activateError: 'सक्रिय करने में त्रुटि',
                deleteError: 'हटाने में त्रुटि',
                modelInfo: 'मॉडल: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ नई आवाज़ जोड़ें',
                newVoice: 'नई आवाज़',
                editVoice: 'आवाज़ संपादित करें',
                emptyState: 'कोई TTS प्रोफ़ाइल उपलब्ध नहीं है। जोड़ने के लिए नीचे क्लिक करें।',
                loadingProfiles: 'TTS प्रोफ़ाइल लोड हो रही है...',
                nameLabel: 'नाम',
                namePlaceholder: 'जैसे: मेरी ElevenLabs एडम',
                providerLabel: 'प्रदाता',
                providerPlaceholder: 'जैसे: ElevenLabs, OpenAI, Piper',
                providerPiper: 'पाइपर (स्थानीय)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API कुंजी *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'मॉडल ID *',
                modelIdPlaceholder: 'जैसे: eleven_monolingual_v1',
                voiceIdLabel: 'आवाज़ ID',
                voiceIdPlaceholder: 'जैसे: pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'सभी फ़ील्ड भरे जाने चाहिए!',
                saveSuccess: '✓ TTS प्रोफ़ाइल सफलतापूर्वक सहेजी गई!',
                deleteConfirm: 'क्या आप वास्तव में "{name}" को हटाना चाहते हैं?',
                loadError: 'TTS प्रोफ़ाइल लोड करने में त्रुटि',
                saveError: 'सहेजने में त्रुटि',
                activateError: 'सक्रिय करने में त्रुटि',
                deleteError: 'हटाने में त्रुटि'
            },
            language: {
                title: 'भाषा चुनें',
                description: 'यूजर इंटरफेस के लिए अपनी पसंदीदा भाषा चुनें'
            },
        },
        chat: {
            ready: 'तैयार',
            start: 'प्रारंभ करें',
            stop: 'रोकें',
            initialMessage: 'वास्तविक समय की बातचीत के लिए प्रारंभ करें पर क्लिक करें।',
            listening: 'सुन रहा हूँ...',
            speaking: 'थॉर्स्टन बोल रहा है...',
            userLabel: 'आप',
            aiLabel: 'AI',
            modalTitle: 'थॉर्स्टन AI चैट',
            inputPlaceholder: 'एक संदेश टाइप करें...',
            send: 'भेजें',
            loginRequired: 'कृपया इस सेवा का उपयोग करने के लिए साइन इन करें।',
            loginButton: 'अभी साइन इन करें',
            magicLinkRequired: 'कृपया साइन इन करने के लिए एक मैजिक लिंक का उपयोग करें।',
            creditLimitError: 'आपका प्रति घंटा कोटा समाप्त हो गया है। जारी रखने के लिए कृपया अपनी योजना (मीडियम/प्रीमियम) अपग्रेड करें।',
            serviceDisabled: 'चैट सेवा वर्तमान में उपलब्ध नहीं है। कृपया बाद में पुनः प्रयास करें।'
        },
        notifications: {
            error: 'त्रुटि',
            success: 'सफलता',
            info: 'सूचना',
            unknownError: 'एक अज्ञात त्रुटि उत्पन्न हुई'
        },
        cookie: {
            message: 'यह वेबसाइट आपको सर्वोत्तम उपयोगकर्ता अनुभव प्रदान करने के लिए कुकीज़ का उपयोग करती है।',
            accept: 'स्वीकार करें'
        },
        curriculum: {
                buttonLabel: 'पाठ्यक्रम',
                buttonTitle: 'पाठ्यक्रम सामग्री दिखाएं',
                modalTitle: '{app} पाठ्यक्रम',
                sections: {
                    topic: 'पाठ्यक्रम विषय',
                    explanation: 'बच्चों के अनुकूल व्याख्या',
                    studentProfile: 'छात्र प्रोफ़ाइल'
                },
                topic: {
                    empty: 'बैकएंड में इस माइक्रो-ऐप से कोई पाठ्यक्रम विषय जुड़ा नहीं है।',
                    missingDetail: 'इस माइक्रो-ऐप के लिए विस्तृत पाठ्यक्रम डेटा अभी बैकएंड में उपलब्ध नहीं है।',
                    learningGoals: 'सीखने के लक्ष्य',
                    prerequisites: 'पूर्वापेक्षाएँ',
                    unitLabel: 'इकाई',
                    durationLabel: 'अवधि',
                    difficultyLabel: 'कठिनाई',
                    hours: 'घंटा',
                    minutes: 'मिनट'
                },
                explanation: {
                    empty: 'कोई बच्चों के अनुकूल व्याख्या उपलब्ध नहीं है।',
                    loadingPrepare: 'AI व्याख्या तैयार कर रहा है',
                    loadingExplain: 'AI बच्चों की भाषा में विषय समझा रहा है',
                    requestFailed: 'बच्चों के अनुकूल व्याख्या उत्पन्न नहीं की जा सकी।'
                },
                studentProfile: {
                    country: 'देश',
                    region: 'राज्य / क्षेत्र',
                    schoolType: 'स्कूल का प्रकार',
                    grade: 'कक्षा',
                    noContext: 'कोई छात्र संदर्भ उपलब्ध नहीं है।',
                    childProfileNotFound: 'वर्तमान लॉगिन के लिए बैकएंड में कोई छात्र प्रोफ़ाइल नहीं मिली।',
                    loginProfileIncomplete: 'लॉगिन प्रोफ़ाइल में अभी तक पूर्ण छात्र संदर्भ नहीं है।',
                    educationContextNotFound: 'एक छात्र प्रोफ़ाइल मिली, लेकिन कोई पाठ्यक्रम असाइनमेंट सेट नहीं है।',
                    noToken: 'कोई साइन-इन छात्र नहीं मिला।'
                },
                errors: {
                    signInRequired: 'कृपया पाठ्यक्रम देखने के लिए साइन इन करें।',
                    appIdMissing: 'ऐप आईडी गायब है।',
                    loadFailed: 'पाठ्यक्रम डेटा लोड नहीं किया जा सका।'
                }
            }
    };
